import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { apiError } from "@/context/AuthContext";
import AuthLayout, { Field, SubmitButton } from "@/pages/AuthLayout";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) { setError(apiError(e2.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthLayout title="Reset password" subtitle="We'll email you a secure reset link.">
      {sent ? (
        <div className="rounded-xl border border-green-200 bg-green-50 p-5 text-sm text-green-800" data-testid="forgot-sent">
          If an account exists for <span className="font-semibold">{email}</span>, a reset link is on its way.
          Check your inbox and follow the link.
        </div>
      ) : (
        <form onSubmit={submit} data-testid="forgot-form">
          <Field label="Email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" placeholder="you@example.com" />
          {error && <p className="text-sm text-red-600 mb-3">{error}</p>}
          <SubmitButton loading={loading} type="submit" data-testid="forgot-submit">Send reset link</SubmitButton>
        </form>
      )}
      <p className="mt-4 text-sm text-ink-soft">
        <Link to="/login" className="text-brand font-medium hover:underline">Back to sign in</Link>
      </p>
    </AuthLayout>
  );
}
